import verreImage from './formatWithoutHeader/verreImage.json';

/**
 * @description Liste des templates
 */
const templates = [verreImage];

/**
 * @function getBindingTemplate
 * @param {string} templateName - nom du template sélectionné par l'utilsateur
 * @description Récupére l'objet json qui correspond au template de binding pour
 * les fichiers qui n'on pas de header
 */

const getBindingTemplate = templateName =>
  templates.find(template => template.templateName === templateName);

export default getBindingTemplate;
